<template>
  <div>
    <common-dialog
      ref="dialog"
      width="350px"
      show-save-button
      unit="中考入口区间设置"
      id-key="ConfigLvId"
      :data="data"
      form-label-width="85px"
      :before-save="onBeforeSave"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="区间序号" prop="Sn">
              <el-input v-model="data.Sn" type="number" placeholder="请填写区间序号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="区间分数" prop="StartValue">
              <el-input v-model="data.StartValue" type="number" style="width:45%" placeholder="分数"></el-input>
              -
              <el-input v-model="data.EndValue" type="number" style="width:45%" placeholder="分数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/achieve/params/lv";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ConfigLvId: 0,
        LvType: 1,
        StartValue: null,
        EndValue: null,
        Sn: null,
        LvName: "",
      },
      api,
      rules: {
        Sn: [{ required: true, message: "请填写区间序号" }],
        StartValue: [{ required: true, message: "请填写分数" }],
      },
      isMB: this.$store.state.isMB
    };
  },
  computed: {},
  methods: {
    onEditOpened() {
    },
    onCreateOpened() {
    },
    onBeforeSave() {
      if(!(this.data.Sn>0&&this.data.Sn%1==0)) {
        this.$message.error("请填写正确的序号")
        return false
      }
      if(!(Number(this.data.StartValue)>=0&&this.data.StartValue%1==0)) {
        this.$message.error("分数须为整数")
        return false
      }
      if(!(this.data.EndValue%1==0)) {
        this.$message.error("分数须为整数")
        return false
      }
      // if(!(Number(this.data.EndValue)>Number(this.data.StartValue))) {
      //   this.$message.error("分数上限须大于下限")
      //   return false
      // }
      return true
    },
  },
};
</script>
<style lang="scss">
</style>